import { render, staticRenderFns } from "./ResultsPerFranchise.vue?vue&type=template&id=0d745cf4&"
import script from "./ResultsPerFranchise.vue?vue&type=script&lang=js&"
export * from "./ResultsPerFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports